import { Fragment } from 'react';
import clsx from 'clsx';
import { useLoadingAnimationCallbackRef } from './utils';
import commonStyles from './Skeleton.module.css';
import styles from './SkeletonLines.module.css';

export function SkeletonLines({ lines }: { lines?: number }) {
  const animationRef = useLoadingAnimationCallbackRef();

  if (!lines) {
    return null;
  }

  return (
    <>
      {Array.from({ length: lines }).map((_, index) => {
        return (
          <Fragment key={index}>
            <span key={index} ref={animationRef} className={clsx(styles.text, commonStyles.animation)}>
              &nbsp;
            </span>
            {index === lines - 1 ? <br /> : null}
          </Fragment>
        );
      })}
    </>
  );
}
